/**
 * 爱豆换算（管理端）
 * ---------------------------------------------------------------------------
 * 库里所有金额字段（balance / amount / fee）存的都是「元」，界面上一律显示「爱豆」。
 * 换算率来自系统配置 bean.per_yuan（默认 1 元 = 10 爱豆），超管可改。
 *
 * ⚠️ 换算率只放在这里一处，页面不要再自己乘 10。
 * ⚠️ 后端返回的金额字段直接丢给 toBean()，不要先格式化再换算。
 */

const DEFAULT_PER_YUAN = 10

let perYuan = DEFAULT_PER_YUAN

export function setBeanRate(rate) {
  const value = Number(rate)
  if (value > 0) {
    perYuan = value
  }
}

export function getBeanRate() {
  return perYuan
}

/** 元 → 爱豆（整数） */
export function toBean(yuan) {
  const value = Number(yuan)
  if (!isFinite(value)) {
    return 0
  }
  return Math.round(value * perYuan)
}

/** 元 → "100" 这样的数字串，带千分位 */
export function beanNumber(yuan) {
  return toBean(yuan).toLocaleString('zh-CN')
}

/** 元 → "100 爱豆" */
export function beanText(yuan) {
  return beanNumber(yuan) + ' 爱豆'
}

/** 元 → "¥10.00"（只在需要同时展示原价的场合用，例如充值配置） */
export function yuanText(yuan) {
  const value = Number(yuan)
  if (!isFinite(value)) {
    return '¥0.00'
  }
  return '¥' + value.toFixed(2)
}

/** 大数字紧凑显示：12345 → 1.23万 */
export function compactNumber(value) {
  const num = Number(value)
  if (!isFinite(num)) {
    return '0'
  }
  if (Math.abs(num) < 10000) {
    return num.toLocaleString('zh-CN')
  }
  if (Math.abs(num) < 100000000) {
    return (num / 10000).toFixed(2).replace(/\.?0+$/, '') + '万'
  }
  return (num / 100000000).toFixed(2).replace(/\.?0+$/, '') + '亿'
}
